import { SALE_ABI } from '@lfg/abis';
import { useCallback } from 'react';
import { useAccount } from 'wagmi';
import { useWatchContractEvent } from 'wagmi';

import type { Address } from '@/global/types/common.type';
import { useAppSelector } from '@/store/utils';

import type { UseWatchBuyEventsProps } from './types/buyNode.type';

const BUY_EVENTS = ['otc'] as const;

export const useWatchBuyOtcEvents = ({ onBuyEvent }: UseWatchBuyEventsProps) => {
  const { address } = useAccount();
  const { projectInfo } = useAppSelector(state => state.project);

  const handleBuyEvent = useCallback(
    async (logs: any) => {
      if (logs[0]?.address.toLowerCase() === address?.toLowerCase()) return;

      if (onBuyEvent) {
        await onBuyEvent();
      }
    },
    [address, onBuyEvent],
  );

  // Register event listeners for all buy events
  BUY_EVENTS.forEach(eventName => {
    useWatchContractEvent({
      address: projectInfo?.sale as Address,
      abi: SALE_ABI,
      eventName,
      onLogs: handleBuyEvent,
      poll: true,
      pollingInterval: 15_000, // HACK: MAGIC NUMBER - Set polling interval to 15s to reduce number of requests to Alchemy
    });
  });
};
